import { render, staticRenderFns } from "./LogCommit.vue?vue&type=template&id=1f25b6eb&lang=pug&"
import script from "./LogCommit.vue?vue&type=script&lang=js&"
export * from "./LogCommit.vue?vue&type=script&lang=js&"
import style0 from "./LogCommit.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports